import { useEffect, useState } from "react";
import { connect } from "react-redux";
import ComponentSwitcher from "../../../_components/component-switcher/component-switcher.component";
import { CustomPushService } from "../../../_service/custom-push.service";
import SettingPageHeaderComponent from "../components/header.setting-component";
import CustomPushLogList from "./custom-push-log-list.component";
import SendCustomPushComponent from "./send-custom-push.component";

export const CUSTOM_PUSH_PAGE_ROUTE = "/settings/custom-push";

function CustomPushPageComponent({ community }) {
  const [showSendCustomPushPage, setShowSendCustomPushPage] = useState(false);

  // get list of all pushes logs

  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageData, setPageData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [itemSelectedToPreview, setItemSelectedToPreview] = useState(null);

  useEffect(() => {
    if (!pageData[currentPage]) {
      getData(currentPage);
    }
  }, [currentPage]);

  useEffect(() => {
    if (itemSelectedToPreview) {
      setShowSendCustomPushPage(true);
    }
  }, [itemSelectedToPreview]);

  const updatePageData = (pageNumber, data, total, forceNew = false) => {
    setPageData({
      ...(forceNew ? {} : pageData),
      [pageNumber]: data,
    });
    setTotal(total);
  };

  const getData = async (pageNumber, forceNew = false) => {
    setIsLoading(true);
    const { pushes, total } = await CustomPushService.getCustomPushLog(
      community.id,
      pageNumber
    );
    setIsLoading(false);
    updatePageData(pageNumber, pushes, total, forceNew);
  };

  const changePage = async (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const refreshDataList = () => {
    setCurrentPage(1);
    setTotal(0);
    setPageData({});
    getData(1, true);
  };

  return (
    <div className="theme-bg-surface">
      <SettingPageHeaderComponent
        pageLabel="Custom Push Notification"
        formLabel="New Custom Push Notification"
        entityName="Custom Push Notification"
        formIconTooltip="Send Custom Push Notification"
        formIcon="envelope-plus"
        isFormVisible={showSendCustomPushPage}
        setIsFormVisible={(val) => {
          setShowSendCustomPushPage(val);
          if (!val) {
            setItemSelectedToPreview(null);
          }
        }}
        refreshDataList={refreshDataList}
      />
      <ComponentSwitcher
        transition="fade"
        isActiveFirst={showSendCustomPushPage}
        child1={
          <SendCustomPushComponent
            itemSelectedToPreview={itemSelectedToPreview}
          />
        }
        child2={
          <CustomPushLogList
            currentPage={currentPage}
            total={total}
            isLoading={isLoading}
            dataList={pageData[currentPage]}
            setIsFormVisible={setShowSendCustomPushPage}
            changePage={changePage}
            setItemSelectedToPreview={setItemSelectedToPreview}
          />
        }
      />
    </div>
  );
}

const CustomPushPage = connect((s) => ({
  community: s.community,
}))(CustomPushPageComponent);

export default CustomPushPage;
